export default {
  OPTIONS: 'options',
  APPLICATION: 'application',
  DIMENSION: 'dimension',
  MATERIAL: 'material',
  LOADS: 'loads',
  DESIGN: 'design',
  CALCULATE: 'calculate',
  PLATE: 'plate',
  ANCHORS: 'anchors'
};



// WEBPACK FOOTER //
// ./src/App/tabs.js